export interface Vendor {
  id: string;
  companyName?: string;
  name: string;
  image: string;
  companyNameKey?: string;
  contactPerson?: string;
  contactPersonKey?: string;
  email?: string;
  phone?: string;
  photo?: string;
  address: string | AddressObject;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  website?: string;
  taxId?: string;
  licenseNumber?: string;
  services?: ServiceType[];
  serviceId: string;
  serviceName: string;
  rating: number;
  totalJobs?: number;
  isActive?: boolean;
  isVerified: boolean;
  isFavourite?: boolean;
  isRegistered?: boolean; // Certified by Stripe (has stripe.accId)
  createdDate?: Date;
  updatedDate?: Date;
  description: string;
  businessDescription: string;
  descriptionKey?: string;
  workingHours?: WorkingHours;
  emergencyContact?: string;
  insuranceInfo?: InsuranceInfo;
  certifications?: Certification[];
}

export interface AddressObject {
  description?: string;
  street?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  zipCode?: string;
  country?: string;
}

export enum ServiceType {
  PLUMBING = 'plumbing',
  ELECTRICAL = 'electrical',
  HVAC = 'hvac',
  CLEANING = 'cleaning',
  MAINTENANCE = 'maintenance',
  SECURITY = 'security',
  LANDSCAPING = 'landscaping',
  PAINTING = 'painting',
  CARPENTRY = 'carpentry',
  OTHER = 'other',
}

export interface WorkingHours {
  monday: DaySchedule;
  tuesday: DaySchedule;
  wednesday: DaySchedule;
  thursday: DaySchedule;
  friday: DaySchedule;
  saturday: DaySchedule;
  sunday: DaySchedule;
}

export interface DaySchedule {
  isWorking: boolean;
  startTime?: string;
  endTime?: string;
  breakStartTime?: string;
  breakEndTime?: string;
}

export interface InsuranceInfo {
  provider: string;
  policyNumber: string;
  expiryDate: Date;
  coverageAmount: number;
  currency: string;
}

export interface Certification {
  id: number;
  name: string;
  issuingAuthority: string;
  issueDate: Date;
  expiryDate?: Date;
  certificateNumber?: string;
  isActive: boolean;
}

export interface VendorReview {
  id: number;
  vendorId: number;
  residentId: number;
  rating: number;
  comment?: string;
  serviceType: ServiceType;
  jobDate: Date;
  createdDate: Date;
  isVerified: boolean;
}
